export const getBreadcrumbs = ({ breadcrumbs }) => {
  if (!Array.isArray(breadcrumbs) || breadcrumbs.length === 0) {
    return {};
  }

  const formattedBreadcrumbs = breadcrumbs.map((breadcrumb) => {
    return { label: breadcrumb.name, browseUrl: breadcrumb.url, url: breadcrumb.url };
  });

  const searchModelFormat = {
    searchModel: {
      taxonomy: {
        breadCrumbs: formattedBreadcrumbs,
      },
    },
  };

  return searchModelFormat;
};
